class ManualLibrary extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('[data-manual-search]');
    this.clearButton = this.querySelector('[data-manual-clear]');
    this.filterButtons = [...this.querySelectorAll('[data-manual-filter]')];
    this.rows = [...this.querySelectorAll('[data-manual-row]')];
    this.categories = [
      ...this.querySelectorAll('.manual-library__category[data-manual-category]'),
    ];
    this.status = this.querySelector('[data-manual-status]');
    this.emptyState = this.querySelector('[data-manual-empty]');
    this.activeCategory = 'all';

    if (!this.searchInput || !this.rows.length) return;

    this.searchInput.addEventListener('input', () => this.update());
    this.clearButton?.addEventListener('click', () => {
      this.searchInput.value = '';
      this.searchInput.focus();
      this.update();
    });

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.manualFilter;
        this.filterButtons.forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        this.update();
      });
    });

    this.update();
  }

  normalize(value) {
    return String(value || '')
      .normalize('NFKD')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  update() {
    const rawQuery = this.searchInput.value.trim();
    const query = this.normalize(rawQuery);
    let visibleCount = 0;

    this.rows.forEach((row) => {
      const matchesQuery = !query || this.normalize(row.dataset.manualSearch).includes(query);
      const matchesCategory =
        this.activeCategory === 'all' || row.dataset.manualCategory === this.activeCategory;
      const visible = matchesQuery && matchesCategory;

      row.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    this.categories.forEach((category) => {
      category.hidden = !category.querySelector('[data-manual-row]:not([hidden])');
    });

    if (this.clearButton) this.clearButton.hidden = !rawQuery;
    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;

    if (this.status) {
      if (rawQuery) {
        this.status.textContent = `${visibleCount} ${visibleCount === 1 ? 'result' : 'results'} for “${rawQuery}”`;
      } else if (this.activeCategory !== 'all') {
        this.status.textContent = `${visibleCount} ${visibleCount === 1 ? 'manual' : 'manuals'}`;
      } else {
        this.status.textContent = '';
      }
    }
  }
}

if (!customElements.get('manual-library')) {
  customElements.define('manual-library', ManualLibrary);
}


document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('ManualLanguageForm');

  if (!form) return;

  form.addEventListener('submit', function (event) {
    const clickedButton = event.submitter;

    if (
      !clickedButton ||
      !clickedButton.classList.contains('manual-language-switcher__button')
    ) {
      return;
    }

    form.classList.add('is-loading');
    form.setAttribute('aria-busy', 'true');

    const buttons = form.querySelectorAll(
      '.manual-language-switcher__button'
    );

    buttons.forEach(function (button) {
      if (button !== clickedButton) {
        button.disabled = true;
      }
    });

    clickedButton.classList.add('is-loading');
  });
});
